import { DestroyableObstacle } from "../destroyableObstacle";
import type { DamageType } from "../damageType";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { DestroyedRock } from "./destroyedRock";
import { Sound } from "./sounds/sound";
import { SoundId } from "./sounds/soundId";

export class Rock extends DestroyableObstacle {
	static key = "Rock";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.ROCK_DEBRIS;
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		this.board!.addNonPhysicalThing(new Sound(SoundId.ROCK_BREAK, this.xy));
		const remnant = new DestroyedRock(this.xy);
		this.board!.addThing(remnant);
		super.onZeroHp(source, type);
	}

	static deserialize(data: any): Rock {
		const c = new Rock(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
